import { csx } from '@vtex/admin-ui'

const styles = {
  list: csx({
    width: 'full',
    rowGap: '$space-2',
  }),

  option: csx({
    "input[type='checkbox']": {
      appearance: 'none',
    },

    ':hover': {
      border: '$form.neutral',
      color: '$primary',
    },

    '[aria-checked="true"]': {
      background: '$action.main.secondary',
      borderColor: 'var(--admin-ui-fg-blue30)',
      color: '$action.main.secondary',
    },

    ':active': {
      color: '$action.main.secondaryHover',
      border: '$form.controlChecked',
      background: '$action.main.secondary',
    },

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '$space-4',
    border: '$neutral',
    borderRadius: 4,
    transition: 'background-color, color 0.1s ease',
    cursor: 'pointer',
    color: 'var(--admin-ui-fg-gray40)',
    width: 'full',

    '[aria-readonly="true"]': {
      pointerEvents: 'none',
      border: '$form.neutral',
      background: '$disabled',
      '[aria-checked="true"]': {
        color: '$primary',
        border: '$disabled',
      },
    },

    '>span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  }),

  skeleton: csx({
    height: 44,
  }),
}

export default styles
